import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

// import LazyLoad      from 'react-lazyload';

import PostPreview   from '@common/post-preview/_post-preview';
// -------------------------------------------------------

class PostCommon extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの表示非表示
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let base = this.props.base;
    
    let post_type = 'feed';
    if( data.product_type == 'REELS' ) post_type = 'reel';
    if( data.product_type == 'STORY' ) post_type = 'story';
    
    let media = [];
    media.push({ media_url: data.media_url });
    try { if( data.children != null ) data.children.split(',').map((url) => { media.push({ media_url: url }); }); } catch(e) {}
    
    // アカウント
    let account = this.props.account;
    if( account == undefined ) account = {};
    
    // マウスオーバー情報の表示
    let preview_mode = this.props.preview_mode;
    
    return (
      <div className={'post-common post_type_'+ post_type }>
        <div className="post-thumbnail">
          <img src={data.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
        </div>
        
        { (Object.keys(account).length > 0) &&
          <div className="post-account">
            <img src={account.thumbnail} />@{account.insta_id}
          </div>
        }
        
        <div className="post-background" onClick={this.toggleModal.bind(this, true)}>
          <div className="post-background-item">
            
            { (preview_mode == 'likes') && <p className="preview-score"><i className="material-icons">favorite</i>{Utils.viewInt(data.likes)}</p> }
            { (preview_mode == 'comments') && <p className="preview-score"><i className="material-icons">chat_bubble</i>{Utils.viewInt(data.comments)}</p> }
            { (preview_mode == 'plays') && <p className="preview-score"><i className="material-icons">play_circle</i>{Utils.viewInt(data.plays)}</p> }
            { (preview_mode == 'plays_per') && <p className="preview-score"><i className="material-icons">play_circle</i>{Utils.viewInt(data.plays_per)}%</p> }
            { (preview_mode == 'impressions') && <p className="preview-score"><i className="material-icons">visibility</i>{Utils.viewInt(data.impressions)}</p> }
            { (preview_mode == 'reach') && <p className="preview-score"><i className="material-icons">visibility</i>{Utils.viewInt(data.reach)}</p> }
            
            <p>{Utils.setDate(data.post_date, 'YYYY/M/D')}</p>
            <p>{Utils.setDate(data.post_date, 'HH:mm')}</p>
          </div>
        </div>
        {/* (this.state.modal == true) && <PostDetail detail={data} close_ev={this.toggleModal.bind(this)} /> */}
        
        <PostPreview view={this.state.modal} base={base} is_api={this.props.is_api} close_ev={this.toggleModal.bind(this)} detail={{
          media        : media,
          account      : account,
          caption      : data.text,
          score        : data,
          shortcode    : data.shortcode,
          post_date    : data.post_date,
          product_type : data.product_type,
          project_id   : this.props.project_id,
          report       : this.props.report,
        }} is_report={this.props.is_report} report_edit={this.props.report_edit} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default PostCommon;